export default __webpack_public_path__ + "static/media/less-cramping-OFF.5df30e8e.png";